<template>
  <section class="blank-history call-history">
    <header class="text-header">
    <Toaster :dataValue="toasterData" />
      <div class="back-btn" @click="back"><img :src='require("../../assets/images/back-icon.svg")' alt="back"></div>
      <h1>{{$t('Callhistory')}}</h1>
    </header>
    <div class="balance-status">
      <h2 v-html="$t('walletbal', {userbal:userDetail && userDetail.gemBalance})"></h2>
      <!-- <button @click="addMoney">पैसे जोड़े </button> -->
    </div>
    <ads-91 :unitIdentifier="productIdentifier" />
    <TermsConditions  v-if="showTermsCondition" :termsConditionClass="termsConditionClass" @closePopUp="closePopUp"/>
    <CallHistoryList v-if="$store.state.netOnOff && callHistory.length" :callHistory="callHistory" />
    <div class="netOff-para" v-if="!$store.state.netOnOff">Please Enable your Internet</div>
    <CallHistoryFooter @handleTermsCondition="handleTermsCondition" :inSufficient="inSufficient"/>
    <Loader v-if="loading && $store.state.netOnOff && !callHistory.length"/>
  </section>
</template>
<script>
import TermsConditions from '../../components/common/TermsConditions'
import CallHistoryFooter from '../../components/common/CallHistoryFooter'
import CallHistoryList from '../../components/CallHistoryList'
import Toaster from "../../components/common/Toaster";
import Loader from "../../components/loader/loader"

export default {
  name: "CallHistory",
  components:{
      TermsConditions,
      CallHistoryFooter,
      CallHistoryList,
      Toaster,
      Loader
  },
  data(){
    return{
      callHistory: [],
      userDetail: null,
      showTermsCondition: false,
      termsConditionClass: false,
      toasterData: {},
      inSufficient: false,
      loading: true,
      productIdentifier: '0592642b-3e91-4241-b7e5-9b585db2b985'
    }
  },

  methods:{
    addMoney(){
      window.location.href = "http://billsbe.payboard.in/load-db-wallet?encodedId=c81e728d9d4c2f636f067f89cc14862c"
    },
    back(){
      this.$router.go(-1)
    },
    closePopUp(){
      this.termsConditionClass = false
      this.showTermsCondition = false 
    },
    handleTermsCondition(){
      if(this.callHistory.length){
        this.termsConditionClass = true
        this.showTermsCondition = true
      }
    },
    callBalance(){
      this.loading = true
      this.$store
      .dispatch({ type: "userDetail" })
      .then(({ data }) => {
        console.log("=", data);
        this.loading = false
        this.$store.commit("UserImage", data.data)
        this.inSufficient = false
        this.userDetail = data.data; 
          if(data.data.gemBalance < 10){
            this.inSufficient = true
            this.toasterData = {
              status: true,
              msg: this.$t("Nosufficientbal"),
              timeoutMs: "5000",
              color: "#330028"
            };
          }
        if (data.data.call_rate > 0) {
          this.$store.commit(
            "MaxSecondForcall",
            Math.floor(data.data.wallet / data.data.call_rate) * 60
          );
        }
      })
      .catch(error => {
        console.log(error);
      });
      this.$cookie.set('code', "0")
    },
    callHistoryList(){
      this.loading = true
      this.$store.dispatch({type: 'getCallerHistory'}).then(({data})=>{
        if(data.data.length){
          this.loading = false
          this.callHistory = data.data
        }else{
          this.loading = false
          this.showTermsCondition = true
        }
        console.log('==data==',this.callHistory)
      })
    }
  },
  sockets:{},
  mounted(){
    console.log('===',this.$route.query.err)
     this.callBalance()
     this.callHistoryList()
     this.$socket.on('connect', () => {
      console.log('==connect=---')
      // this.$store.commit('DisconnectingStatus', false)
     this.callBalance()
     this.callHistoryList() 
    })
  }
}
</script>